import { SparklesIcon } from "@heroicons/react/24/outline";

interface RouteChangePromptProps {
  visible: boolean;
  onStartNewSession: () => void;
  onDismiss?: () => void;
}

export function RouteChangePrompt({
  visible,
  onStartNewSession,
  onDismiss,
}: RouteChangePromptProps) {
  if (!visible) return null;

  return (
    <div className="mb-3">
      <div className="group relative w-full rounded-2xl border border-blue-200/60 bg-gradient-to-br from-blue-50 to-indigo-50 p-4 text-gray-800 shadow-md">
        <div className="flex items-start gap-2">
          <SparklesIcon className="h-5 w-5 flex-shrink-0 text-indigo-500" />
          <div className="space-y-2">
            <p className="text-sm leading-relaxed">
              Navigating to a new area of Foundry can create a new chat session
              for you. Press the button below to start a new conversation.
            </p>
            <div className="flex items-center justify-between">
              <button
                type="button"
                onClick={onDismiss}
                className="text-xs font-medium text-gray-500 hover:text-gray-700 underline">
                Dismiss
              </button>
              <button
                type="button"
                onClick={onStartNewSession}
                className="inline-flex items-center gap-1 rounded-full bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors duration-200 hover:bg-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                <SparklesIcon className="h-4 w-4" />
                <span>Start new conversation</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
